import React from 'react'
import PropTypes from 'prop-types'
import PromoUnit from '../PromoUnit'

const SOPQPromo = props => {
  return (
    <PromoUnit
      headingText={props.sopqContent.sopqHeadingText}
      bodyText={props.sopqContent.sopqBodyText}
    >
      {props.children}
    </PromoUnit>
  )
}

SOPQPromo.displayName = 'SOPQPromo'

SOPQPromo.propTypes = {
  sopqContent: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default SOPQPromo
